// extracted by mini-css-extract-plugin
export default {"innerWrapper":"GE-z","tooltipWrapper":"HE-z","icon":"IE-z","tooltip":"JE-z","content":"KE-z"};